var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-menu-toggle",attrs:{"id":"mobile-menu-toggle"},on:{"click":function($event){return _vm.$emit('toggle_mobile_menu')}}},[_c('span',{staticClass:"mobile-menu-toggle__x",class:{
      'mobile-menu-toggle__x--open' : !_vm.open_mobile_menu && !_vm.first_load,
      'mobile-menu-toggle__x--close' : _vm.open_mobile_menu && !_vm.first_load
    }},[_c('div'),_c('div'),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }